<div class="row">

  <div class="padding">
    <a href=".">
      <span class="explosys">ExploSYS</span><br>
      <span>exploratory systems</span>
    </a>
  </div>

  <img class="banner" src="./assets/banners/Banner2.jpg">
</div>

